// extracted by mini-css-extract-plugin
module.exports = {"redmineWidget":"g_PH-ecZuzpVo1Jfz7iNW","bodyHasRedmineWidget":"_1Mf5uiB0mGcoQg0Gnhgco9"};